import client from './client';
import { AppUser, UserDetail } from '../types/user';
import { ListResult, normalizeList } from '../utils/list';

export interface UserListParams {
  search?: string;
  page?: number;
  limit?: number;
  /** 'yes' = has ordered, 'no' = never ordered; omit for everyone. */
  purchased?: 'yes' | 'no';
  /** Inclusive signup-date bounds, YYYY-MM-DD. */
  joined_from?: string;
  joined_to?: string;
}

/** The auth service stores names as display_name and booleans as 0/1. */
function fromApi(row: any): AppUser {
  return {
    ...row,
    name: row.display_name ?? row.name ?? '',
    is_verified: Boolean(row.is_verified),
    is_active: row.is_active === undefined ? undefined : Boolean(row.is_active),
  };
}

export async function getUsers(params: UserListParams = {}): Promise<ListResult<AppUser>> {
  const limit = params.limit ?? 20;
  const res = await client.get('/api/admin/users', { params: { ...params, limit } });
  const result = normalizeList<any>(res.data, 'users', limit);
  return { ...result, items: result.items.map(fromApi) };
}

export async function getUser(id: string): Promise<UserDetail> {
  const res = await client.get(`/api/admin/users/${id}`);
  const raw = res.data ?? {};
  return {
    user: fromApi(raw.user ?? raw),
    profile: raw.profile ?? null,
    saved_addresses: (raw.saved_addresses ?? []).map((a: any) => ({
      ...a,
      is_default: Boolean(a.is_default),
    })),
    recent_orders: raw.recent_orders ?? [],
  };
}
